import { useAuth } from '@/hooks/useAuth';
import { SeatStatus } from '@/services/seatAssignmentService';

/**
 * Returns true when the current user is allowed to hit seat-gated API endpoints.
 *
 * Mirrors the backend enforceSeatStatus rule: only an ACTIVE seat passes. SuperAdmin
 * and company-type users have no seat concept and are always allowed. Use this to gate
 * React Query `enabled` / SSE connections so a null/RESERVED user does not fire requests
 * that would return 403 (e.g. /notifications, /dashboard/pending-approvals, /events).
 *
 * NOTE: unlike useAccessRestriction, this does NOT bypass for account-settings:manage —
 * the backend seat gate does not exempt admins, so admins without an ACTIVE seat must
 * also avoid these calls.
 */
export function useHasActiveSeat(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  if (user.isSuperAdmin || user.isCompany) return true;
  return user.seatStatus === SeatStatus.ACTIVE;
}
